import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode, Thumbs, EffectFade } from "swiper";
import { Link } from "react-router-dom";
const ClientAreaFour = ({ data }) => {
  return (
    <div className="client-area-3 mb-2 ">
      <div className="container">
        <div className="row gx-80 gy-4">
          <div className="col-lg-12">
            <div className="client3-wrap">
              <div className="title-area mb-0">
                <h2 className="sec-title">{data?.title}</h2>
                <p className="sec-text">
                  <span
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientAreaFour;
